module.exports = __webpack_public_path__ + "img/icon_email.e4908356.png";